import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { TransactionOverviewDetailsItem } from './TransactionOverviewDetailsItem'
import { formatCurrency } from '@coingecko/cryptoformat'
import { ArrowRightIcon } from 'lucide-react'

interface NumberValueChangeProps {
  label: string
  currentValue: NormalizedUnitNumber
  updatedValue?: NormalizedUnitNumber
}

export function NumberValueChange({ label, currentValue, updatedValue }: NumberValueChangeProps) {
  if (updatedValue === undefined || currentValue.eq(updatedValue)) {
    return (
      <TransactionOverviewDetailsItem label={label}>
        <NumberValue value={currentValue} />
      </TransactionOverviewDetailsItem>
    )
  }

  return (
    <TransactionOverviewDetailsItem label={label}>
      <div className="flex flex-row items-center gap-2">
        <NumberValue value={currentValue} />
        <ArrowRightIcon className="h-5 w-5 text-muted-foreground" />
        <NumberValue value={updatedValue} />
      </div>
    </TransactionOverviewDetailsItem>
  )
}

function NumberValue({
  value,
}: {
  value: NormalizedUnitNumber
}) {
  return <span className="text-center">{formatCurrency(value.toNumber(), 'USD')}</span>
}
